export default __webpack_public_path__ + "static/media/1778.770ca8ca.png";